function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { px2rem, font, padding } from '../../utils/helpers';
var StyledInput = styled.input(_templateObject(), function (_ref) {
  var _extends2;

  var theme = _ref.theme,
      id = _ref.id,
      hasIcon = _ref.hasIcon,
      hasError = _ref.hasError,
      isEmpty = _ref.isEmpty,
      isUnchangeable = _ref.isUnchangeable;
  var colors = theme.colors,
      text = theme.text,
      input = theme.input;
  return _extends({
    display: 'block',
    width: '100%'
  }, font({
    fontFamily: text.shared.normal.fontFamily,
    fontWeight: text.shared.normal.fontWeight,
    fontSize: text.standard.xlarge.fontSize,
    lineHeight: text.standard.xlarge.lineHeight
  }), {
    color: colors[input.field["default"].color],
    backgroundColor: colors[input.field["default"].backgroundColor],
    transition: 'border-color .2s ease-in-out, outline-offset .2s ease-in-out',
    border: 'none',
    borderBottomStyle: 'solid',
    borderBottomWidth: px2rem(!hasError ? input.field["default"].borderWidth : input.field.error.borderWidth),
    borderBottomColor: !hasError ? colors[input.field["default"].borderColor] : colors[input.field.error.borderColor]
  }, padding({
    paddingTop: input.paddingTop,
    paddingBottom: !hasError ? input.paddingBottom - input.field["default"].borderWidth : input.paddingBottom - input.field.error.borderWidth,
    paddingLeft: input.paddingLeft,
    paddingRight: !hasIcon ? input.paddingRight : input.paddingRight * 2 + input.icon.size
  }), (_extends2 = {
    textOverflow: 'ellipsis',
    // outlineOffset: px2rem(input.outlineOffset),
    outline: 0,
    '& + label svg': {
      transition: 'outline-offset .2s ease-in-out',
      outlineOffset: px2rem(input.outlineOffset),
      path: {
        fill: !hasError ? colors[input.icon["default"].color] : colors[input.icon.error.color]
      }
    },
    '& + label svg:focus': {
      outline: px2rem(input.outlineWidth) + " solid " + colors[input.outlineColor],
      outlineOffset: 0
    },
    '&:hover': {
      borderBottomColor: colors[input.field.focus.borderColor]
    },
    '&:focus': {
      paddingBottom: px2rem(input.paddingBottom - input.field.focus.borderWidth),
      borderBottomWidth: px2rem(input.field.focus.borderWidth),
      borderBottomColor: hasError && !isEmpty ? colors[input.field.error.borderColor] : colors[input.field.focus.borderColor] // outline: `${px2rem(input.outlineWidth)} solid ${input.outlineColor}`,
      // outlineOffset: 0,

    },
    '&:disabled': {
      color: !isUnchangeable ? colors[input.field.disabled.color] : undefined,
      borderBottomColor: !isUnchangeable ? colors[input.field.disabled.borderColor] : 'transparent'
    },
    '&:hover + label': !isUnchangeable && {
      color: colors[input.label.hover.color]
    },
    '&:focus + label': {
      paddingTop: px2rem(input.paddingBottom - input.field["default"].borderWidth),
      paddingBottom: px2rem(input.paddingTop - input.paddingBottom + input.field["default"].borderWidth - text.mention.xlarge.lineHeight),
      fontSize: px2rem(text.mention.xlarge.fontSize),
      lineHeight: px2rem(text.mention.xlarge.lineHeight),
      color: hasError && !isEmpty ? colors[input.label.error.color] : colors[input.label.focus.color]
    }
  }, _extends2["&:focus ~ #" + id + "-error"] = {
    display: !isEmpty ? 'block' : 'none'
  }, _extends2['& + label'] = !isEmpty && {
    paddingTop: px2rem(input.paddingBottom - input.field["default"].borderWidth),
    paddingBottom: px2rem(input.paddingTop - input.paddingBottom + input.field["default"].borderWidth - text.mention.xlarge.lineHeight),
    fontSize: px2rem(text.mention.xlarge.fontSize),
    lineHeight: px2rem(text.mention.xlarge.lineHeight),
    color: !hasError ? colors[input.label["default"].color] : colors[input.label.error.color]
  }, _extends2['&:disabled + label'] = !isUnchangeable && {
    color: colors[input.label.disabled.color],
    'svg > path': {
      fill: colors[input.label.disabled.color]
    }
  }, _extends2["&:disabled ~ #" + id + "-helper"] = !isUnchangeable && {
    color: colors[input.helper.disabled.color]
  }, _extends2['::-ms-clear'] = {
    display: 'none'
  }, _extends2));
});
export default StyledInput;